import { BreakPoints } from '@picsart/cascade';
import { FontWeight, ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ colors, breakpoints }: ITheme) => ({
    root: {
      marginBottom: 8,
    },
    container: {
      border: '2px solid var(--backgrounds-tint-3)',
      borderRadius: 12,
      padding: [12, 16],
      marginBottom: 12,

      '&.Result-rephrase': {
        backgroundColor: 'var(--backgrounds-tint-1)',

        '&$editable': {
          backgroundColor: 'var(--backgrounds-positive)',
        },
      },

      '&.Result-recent': {
        backgroundColor: 'var(--backgrounds-tint-1)',

        '&$editable': {
          backgroundColor: 'var(--backgrounds-positive)',
        },
      },
    },

    editable: {
      backgroundColor: 'var(--backgrounds-positive)',
    },

    inputClassName: {
      resize: 'none',
      overflowY: 'hidden',
      marginTop: 16,
      padding: [14, 16],
      width: '100%',
      backgroundColor: '#var(--x-bg-12)',
      border: '2px solid var(--x-border-1)',
      borderRadius: 8,
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: FontWeight.SemiBold,
      color: colors.black,
      background: 'white',
      outline: 'none',
      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:active,&:-webkit-autofill:focus':
        {
          boxShadow: `0 0 0 1000px white inset !important`,
        },
    },

    buttonsAndCount: {
      borderRadius: 12,
      display: 'flex',
      alignItems: 'center',
      marginTop: 12,
      flexWrap: 'wrap',
      gap: 12,
    },
    wordCount: {
      marginRight: 'auto',
      [mediaQuery(breakpoints.mobile)]: {
        flexBasis: '100%',
      },
    },
    wordLabel: {
      color: 'var(--x-text-color-6)',
      fontSize: 12,
      lineHeight: '20px',
      fontWeight: FontWeight.SemiBold,
      marginBottom: 'auto',
    },
    icon: {
      height: 20,
      width: 20,
    },
    buttons: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      justifyContent: 'flex-start',
      [mediaQuery(BreakPoints.Small)]: {
        flexWrap: 'nowrap',

        '& > *': {
          flex: 1,
        },
      },
    },
    rephraseButton: {
      '& .mobile': {
        display: 'none',
      },
      [mediaQuery(BreakPoints.Small)]: {
        '& .desktop': {
          display: 'none',
        },
        '& .mobile': {
          display: 'block',
        },
      },
    },
  }),
  { name: 'Result' },
);
export default useStyles;
